import { APISettings } from '../../config/ApiSettings';
import { BaseAPI } from './baseApi';

const baseUrl = new APISettings().getApiURL();

class AppUserAPI<AppUser> extends BaseAPI {
  public getAppUserById: (id: string) => Promise<any> = async (id: string) => {
    return (await BaseAPI.axios.get(`${baseUrl}/appUser`)).data.output;
  };

  public getAllAppUsers: () => Promise<any> = async () => {
    return (await BaseAPI.axios.get(`${baseUrl}/appUser`)).data.output;
  };

  public updateAppUser: (appUser: AppUser) => Promise<any> = async (appUser: AppUser) => {
    return await BaseAPI.axios.put(`${baseUrl}/appUser/`, appUser);
  };

  public getRolesForAppUser: (id: string) => Promise<any> = async (id: string) => {
    try {
      const response = await BaseAPI.axios.get(`${baseUrl}/appUserRole/GetRolesForAppUser/${id}`);
      return response.data.output;
    } catch (error) {
      return null;
    }
  };

  public createAppUserRole: (userId: string, roleName: string) => Promise<any> = async (
    userId: string,
    roleName: string
  ) => {
    return (await BaseAPI.axios.post(`${baseUrl}/appUserRole/AddUserToRole/${userId}/${roleName}`))
      .data.output;
  };

  public deleteAppUserRole: (userId: string, roleName: string) => Promise<any> = async (
    userId: string,
    roleName: string
  ) => {
    return (
      await BaseAPI.axios.delete(`${baseUrl}/appUserRole/RemoveUserFromRole/${userId}/${roleName}`)
    ).data.output;
  };

  public getAllRoles: () => Promise<any> = async () => {
    return (await BaseAPI.axios.get(`${baseUrl}/role`)).data.output;
  };
}

export const appUserAPI = new AppUserAPI();
